import * as Actions from './actions/actions'
import { settings } from '../../../settings/settings-util'
import uuid from 'uuid'

let resetSessionId = (store, passedSettings) => {
    let selectedSettings = passedSettings || settings;
    store.dispatch(Actions.resetSessionId(
        uuid.v4(), 
        selectedSettings.stateLocations.Conversation.sessionId,
        selectedSettings.stateLocations.Conversation.isActiveSession
    ));
};

let clearHistoryInState = (store, passedSettings) => {
    let selectedSettings = passedSettings || settings;
    store.dispatch(Actions.clearHistoryMessages(selectedSettings.stateLocations.History.Messages));
};

let clearHistoryInAgent = (passedSettings) => {
    const selectedSettings = passedSettings || settings;
    const conversationArea = document.getElementsByClassName(selectedSettings.classNames.conversationAreaClassName);

    if (conversationArea && conversationArea[0] && conversationArea[0].innerHTML)
    {
        conversationArea[0].innerHTML = '';
    }
};

let addNotificationMessage = (store, passedSettings) => {
    let selectedSettings = passedSettings || settings;
    let payload = {
        type: selectedSettings.messageConstants.notificationType,
        text: selectedSettings.endSession.notificationMessage,
    };
    let stateLocation = selectedSettings.stateLocations.History.Messages;
    store.dispatch(Actions.appendHistoryMessage(payload, stateLocation));
};

let hideTimeoutWarning = (store, passedSettings) =>
{
    let selectedSettings = passedSettings || settings;
    let location = `${selectedSettings.stateLocations?.Window?.TimeoutWarning?.Base}.${selectedSettings.stateLocations?.Window?.TimeoutWarning?.Visible}`;
    store.dispatch(Actions.hideTimeoutWarningAction(location));
};

let setInactivityTime = (time, store, passedSettings) =>
{
    let selectedSettings = passedSettings || settings;
    let location = `${selectedSettings.stateLocations?.Window?.TimeoutWarning?.Base}.${selectedSettings?.stateLocations?.Window?.TimeoutWarning?.InactivityTime}`;
    store.dispatch(Actions.setInactivityTimeAction(time, location));
};

let setSessionStartTime = (time, store, passedSettings) =>
{
    let selectedSettings = passedSettings || settings;
    let location = `${selectedSettings?.stateLocations?.Window?.TimeoutWarning?.Base}.${selectedSettings?.stateLocations?.Window?.TimeoutWarning?.SessionStartTime}`;
    store.dispatch(Actions.setSessionStartTimeAction(time, location));
};

let showTimeoutWarning = (store, passedSettings) =>
{
    let selectedSettings = passedSettings || settings;
    let location = `${selectedSettings.stateLocations?.Window?.TimeoutWarning?.Base}.${selectedSettings.stateLocations?.Window?.TimeoutWarning?.Visible}`;
    store.dispatch(Actions.showTimeoutWarningAction(location));
};

let refreshPersistedState = (store, passedSettings) =>
{
    let selectedSettings = passedSettings || settings;
    let location = `${selectedSettings.stateLocations.Window?.TimeoutWarning?.Base}.${selectedSettings.stateLocations?.Window?.TimeoutWarning?.ResetPersist}`;
    store.dispatch(Actions.refreshPersistedStateAction(location, true));
};

export {
    resetSessionId,
    clearHistoryInState,
    clearHistoryInAgent,
    addNotificationMessage,
    hideTimeoutWarning,
    setInactivityTime,
    setSessionStartTime,
    showTimeoutWarning,
    refreshPersistedState
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-end-session/lib/lib-end-session.js